import { differenceInMinutes } from "date-fns";
import { useEffect } from "react";

import { REPORT_TYPE_KEYS, ReportType } from "constants/reports/report-type";

import { useAgentFlag } from "../use-agent-flag";

export function useLastVisitedReport(type: ReportType): void {
  const [lastVisitedDate, setVisitedDate] = useAgentFlag(REPORT_TYPE_KEYS[type]);

  const shouldUpdate = !lastVisitedDate || Math.abs(differenceInMinutes(new Date(), lastVisitedDate)) > 2;

  useEffect(() => {
    if (shouldUpdate) {
      setVisitedDate(new Date().toISOString());
    }
  }, [setVisitedDate, shouldUpdate]);
}
